import React from "react"
const CloseIcon = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      style={{ marginLeft: "0px", marginRight: "0px" }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15 1L8 8L15 15" stroke="#002F6C" strokeWidth="2" />
      <path d="M1 1L8 8L1 15" stroke="#002F6C" strokeWidth="2" />
    </svg>
  )
}
export default CloseIcon
